import React from 'react';
import { Sparkles } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';

const OptimizationTips = ({ tips, onApplyContent, onAddHashtag }) => {
  if (!tips) return null;

  return (
    <Card className="border-emerald-200 bg-emerald-50">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-semibold text-emerald-700 flex items-center gap-2">
          <Sparkles className="h-4 w-4" />
          AI Suggestions
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0 text-sm">
        <div className="space-y-3">
          {tips.score && (
            <div className="flex items-center gap-2">
              <span className="text-slate-600">Score:</span>
              <Badge className={`${
                tips.score >= 80 ? 'bg-green-100 text-green-700' :
                tips.score >= 60 ? 'bg-amber-100 text-amber-700' :
                'bg-red-100 text-red-700'
              }`}>
                {tips.score}/100
              </Badge>
            </div>
          )}
          {tips.suggested_hashtags && (
            <div>
              <p className="text-slate-600 mb-1">Suggested hashtags:</p>
              <div className="flex flex-wrap gap-1">
                {tips.suggested_hashtags.slice(0, 5).map((tag) => (
                  <Badge
                    key={tag}
                    variant="outline"
                    className="cursor-pointer hover:bg-emerald-100"
                    onClick={() => onAddHashtag(tag)}
                  >
                    {tag}
                  </Badge>
                ))}
              </div>
            </div>
          )}
          {tips.improved_content && (
            <div>
              <p className="text-slate-600 mb-1">Improved content:</p>
              <Button
                variant="outline"
                size="sm"
                onClick={() => onApplyContent(tips.improved_content)}
                className="w-full"
              >
                Apply Suggestion
              </Button>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default OptimizationTips;
